import { t } from "ttag";

import { CardLink, CardText, TextLink } from "../AuthButton/AuthButton.styled";

interface SamlButtonProps {
  redirectUrl?: string;
  isCard?: boolean;
}

const getSSOUrl = (redirectUrl?: string) =>
  redirectUrl
    ? `/auth/sso?redirect=${encodeURIComponent(redirectUrl)}`
    : "/auth/sso";

export const SamlButton = ({
  redirectUrl,
  isCard,
}: SamlButtonProps): JSX.Element => {
  const url = getSSOUrl(redirectUrl);

  return isCard ? (
    <CardLink to={url} reloadDocument>
      <CardText>{t`Sign in with SAML`}</CardText>
    </CardLink>
  ) : (
    <TextLink to={url} reloadDocument>
      {t`Sign in with SAML`}
    </TextLink>
  );
};
